import ThemeSettings from './ThemeSettings'
export default ThemeSettings
